/**
 * API client — configured ky instance with JWT interceptor.
 */

import ky from "ky";
import { useAuthStore } from "@/stores/auth-store";

const API_BASE = import.meta.env.VITE_API_URL || "";

export const api = ky.create({
  prefixUrl: API_BASE,
  timeout: 30000,
  retry: { limit: 1, statusCodes: [408, 500, 502, 503, 504] },
  hooks: {
    beforeRequest: [
      (request) => {
        const token = useAuthStore.getState().token;
        if (token) {
          request.headers.set("Authorization", `Bearer ${token}`);
        }
      },
    ],
    afterResponse: [
      async (_request, _options, response) => {
        if (response.status === 401) {
          useAuthStore.getState().logout();
          window.location.href = "/login";
        }
      },
    ],
  },
});
